// ── checkinDue ────────────────────────────────────────────────────────────────
// When "did you finish it?" may ask. Pure, so it is testable without Supabase.
//
// The clock used to be show.episode_run_time[0] || 40, plus 8 minutes. TMDB leaves
// episode_run_time empty for most current shows, so 29 of the last 36 sessions ran
// on the 40-minute default while people actually took 65 minutes on average: the
// card asked at 48 minutes, mid-episode (Jason, 2026-10-22: "it's typically way
// early and it should be the latter"). Now the EPISODE's own runtime wins, the
// show-level figure is the fallback, the default is an hour, and the buffer covers
// a pause and the credits. Late beats early: a prompt that arrives after you've
// already marked is simply never shown; one that arrives mid-episode is a lie.
export const CHECKIN_BUFFER_MIN = 15
export const DEFAULT_RUNTIME_MIN = 60

export function checkinRuntimeMinutes({ episodeRuntime, showRuntime } = {}) {
  const ep = Number(episodeRuntime), sh = Number(showRuntime)
  if (ep > 0) return Math.round(ep)
  if (sh > 0) return Math.round(sh)
  return DEFAULT_RUNTIME_MIN
}

export function checkinDueAt(startedAt, runtimes) {
  const t = startedAt instanceof Date ? startedAt.getTime() : Number(startedAt)
  return new Date(t + (checkinRuntimeMinutes(runtimes) + CHECKIN_BUFFER_MIN) * 60000)
}
